<template>
  <div class="video-player">
    <video ref="videoPlayer" class="video-js"></video>
  </div>
</template>

<script>
  import videojs from 'video.js';
  // video.js does not work without its own stylesheet: unstyled, .vjs-tech
  // falls back to an inline element and the control bar renders as a plain
  // block, so the player cannot be operated at all. The only other import of
  // this file in the repo is views/ui-elements/card/CardBasic.vue, a Vuexy
  // demo page that never loads on an app screen -- so every real consumer was
  // running video.js with no CSS.
  import 'video.js/dist/video-js.css';

  export default {
    name: "VideoPlayer",
    props: {
      options: {
        type: Object,
        default() {
          return {};
        }
      }
    },
    data() {
    return {
      player: null
    }
  },
  mounted() {
    const self = this;
    this.player = videojs(this.$refs.videoPlayer, this.options, function onPlayerReady() {
      // `this` is the video.js player. Emitting it rather than `self.player`
      // avoids depending on whether the assignment above has completed yet.
      self.$emit('ready', this);
    });
    this.$forceUpdate();
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
    }
  }
}
</script>

<style lang="scss">
// Everything this block used to carry -- width/padding-top overrides on
// .video-js, an overflow:hidden clip, absolute positioning for the control
// bar -- existed only to contain a video.js that had no stylesheet. With
// video-js.css imported above, those rules fight the real layout instead:
// `padding-top: 0 !important` collapses the vjs-fluid intrinsic-ratio box to
// zero height, and overflow:hidden then clips the control bar out of view.
.video-player {
  width: 100%;
  position: relative;
}
</style>
